const dirtyTokens = new Set<string>();
let reporter: ((dirty: boolean) => void) | null = null;

export function setRuntimeDirtyReporter(value: ((dirty: boolean) => void) | null): void {
  reporter = value;
  reporter?.(dirtyTokens.size > 0);
}

export function setRuntimeDirty(token: string, dirty: boolean): void {
  if (dirty) dirtyTokens.add(token);
  else dirtyTokens.delete(token);
  reporter?.(dirtyTokens.size > 0);
}

export function clearRuntimeDirty(): void {
  dirtyTokens.clear();
  reporter?.(false);
}
